import { api } from '../../helpers/Api';
var default_1 = /** @class */ (function () {
    function default_1() {
    }
    default_1.prototype.put = function (data) {
        return api.put('client/acount/paymentGateway', data);
    };
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/PaymentGatewayOptions/Store.ts
// module id = 764
// module chunks = 0